<template>
  <FormModal
    v-if="data"
    title="Edit Site Custom Script"
    method="PUT"
    :endpoint="`partners/${partner_id}/sites/${site_id}/custom-scripts/${custom_js_id}`"
    :data="data"
    v-bind="$attrs"
    size="wide"
    @success="success"
  >
    <Alert type="info" class="mb-8"
      >When enabling/disabling a custom script, the cache will be cleared for the site but the changes may not be
      immediately visible when using the CDN.</Alert
    >

    <InputGroup label="Target" name="target" description="Which script should this custom script be included with.">
      <Select v-model="data.target" endpoint="options/script-names" prepend-option="All Scripts" disabled />
    </InputGroup>

    <InputGroup label="Description" name="description" description="Describe what this custom script does/is for.">
      <TextInput v-model="data.description" />
    </InputGroup>

    <InputGroup
      label="Custom Script"
      name="content"
      description="The custom script code with no wrapping functions. Example: window.alert('Hello, world!');"
    >
      <TextInput v-model="data.content" textarea :rows="20" />
      <Button prepend-icon="magic" class="mt-2" @click="checkScript()">Check script</Button>
    </InputGroup>

    <InputGroup label="Enabled" name="enabled">
      <ToggleSwitch v-model="data.enabled" label="Enable this custom script" />
    </InputGroup>
  </FormModal>
</template>

<script>
import CheckScriptStyleMixin from "./CheckScriptStyleMixin"

export default {
  props: {
    partner_id: {
      type: Number,
      required: true
    },
    site_id: {
      type: Number,
      required: true
    },
    custom_js_id: {
      type: Number,
      required: true
    }
  },
  mixins: [CheckScriptStyleMixin],
  data: () => ({
    data: {
      target: null,
      description: "",
      content: "",
      enabled: true
    }
  }),
  async mounted() {
    let response = await this.$api.get(
      `partners/${this.partner_id}/sites/${this.site_id}/custom-scripts/${this.custom_js_id}`
    )
    this.data = response.data.data
    this.data.target = "copilot"
    this.loading = false
  },
  methods: {
    success(result) {
      this.$notification.success(`Custom script successfully updated.`)
      this.$emit("close", result)
    }
  }
}
</script>
